export default "__VITE_ASSET__DUBC_fOI__"